import { useEffect } from "react";
import "./index.css";

function AdSenseMain() {
    useEffect(() => {
        try {
            if (window.adsbygoogle) {
                window.adsbygoogle.push({});
            }
        } catch (error) {
            console.error("AdSenseMain error", error);
        }
    }, []);

    return (
        <div className="adsense-main-wrapper my-5">
            <ins
                className="adsbygoogle"
                data-ad-client="ca-pub-1757046056951934"
                data-ad-format="fluid"
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-slot="6413277057"
                style={{ display: "block" }}
            />
        </div>
    );
}

export default AdSenseMain;
